import React from 'react';
import { useBasicEventInfoQuery } from '../../utils/eventInfo/basicEventInfo.graphql.generated';
import PageNotFound from './PageNotFound';
import { useEventUserRole } from '@shared/components/AuthProvider';
import { isInIframe } from '@shared/utils/isInIframe';

export interface PageNotFoundWrapperProps {
  eventHandle: string;
}

const isPreviewing = isInIframe();

export const PageNotFoundWrapper: React.FC<PageNotFoundWrapperProps> = props => {
  const { isAdmin } = useEventUserRole();
  const { data, loading } = useBasicEventInfoQuery({
    ssr: true,
    batchMode: 'fast',
    fetchPolicy: 'cache-and-network',
    variables: { eventHandle: props.eventHandle, isAdmin: isPreviewing && isAdmin },
  });

  if (!loading && !data?.eventByName?.id) {
    return <PageNotFound />;
  }

  return <>{props.children}</>;
};
